import { useState, useEffect } from 'react';

const useScrollHeader = () => {
  const [isFloating, setIsFloating] = useState(false);
  const scrollThreshold = 100; // pixels to scroll before header changes

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if (scrollTop > scrollThreshold) {
        setIsFloating(true);
      } else {
        setIsFloating(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return isFloating;
};

export default useScrollHeader; 